/**
 * The picture slot on a build page.
 *
 * The CEO asked for pictures here and they are not available yet: PM ruled that none of the images
 * we currently hold are publishable — they must show the surfaces a release actually touched, in a
 * true state, on a device set up the way a tester's is, and what we have is test-harness output —
 * and #241 blocks producing new ones, because the capture harness cannot render a service-ON
 * screen at all, by construction.
 *
 * So this slot is built to STAY EMPTY WITHOUT LOOKING BROKEN, and deliberately not filled from
 * what happens to be on disk. It states why there is nothing here, which is a different thing from
 * a blank space that reads as a rendering failure — and a different thing again from quietly
 * showing an image that misrepresents the release.
 */
export function ReleasePictures({ images }: { images?: { url: string; caption?: string }[] }) {
  if (!images?.length) {
    return (
      <div className="panel muted" style={{ fontSize: 13 }}>
        No pictures for this release yet. They are meant to show the surfaces this build actually
        changed, on a device set up like a tester's — the images we can currently produce show the
        test harness instead, so none are published here.
      </div>
    );
  }
  return (
    <div className="row" style={{ gap: 8, flexWrap: "wrap" }}>
      {images.map((im) => (
        <figure key={im.url} style={{ margin: 0 }}>
          <img src={im.url} alt={im.caption ?? "release screenshot"} style={{ maxWidth: 260, borderRadius: 4 }} />
          {im.caption && <figcaption className="muted" style={{ fontSize: 12 }}>{im.caption}</figcaption>}
        </figure>
      ))}
    </div>
  );
}
